import React, { FC, ReactNode } from 'react';
import { RouterLocation } from '@funtech-int/rival';
import classnames from 'classnames';

import { RouterLink } from '@/shared/components/RouterLink/RouterLink';

import AngleIcon from '../../assets/Angle';

import styles from './_SelectionTitle.module.css';

const SUBTITLE_MAX_LENGTH = 80;

interface SelectionTitleProps {
    title: ReactNode;
    subtitle?: string;
    location?: RouterLocation<any, any>;
    searchParams?: URLSearchParams;
    className?: string;
    iconClassName?: string;
    onClick?(): void;
}

function cutString(str: string, maxLength: number, ending: string) {
    if (str.length <= maxLength) {
        return str;
    }

    return str.slice(0, maxLength).replace(/\s+$/, '') + ending;
}

export const SelectionTitle: FC<SelectionTitleProps> = ({
    title,
    subtitle,
    location,
    searchParams,
    className,
    iconClassName,
    onClick,
}) => {
    let content = <h2 className={styles.title}>{title}</h2>;

    if (location) {
        content = (
            <RouterLink
                to={location}
                searchParams={searchParams}
                className={styles.titleLink}
                onClick={onClick}
            >
                {content}
                <AngleIcon
                    className={classnames(styles.titleLinkIcon, iconClassName)}
                    aria-hidden
                />
            </RouterLink>
        );
    }

    return (
        <header className={classnames(styles.root, className)} data-tid="SelectionTitle">
            {content}
            {subtitle ? (
                <h3 className={styles.subtitle}>
                    {cutString(subtitle, SUBTITLE_MAX_LENGTH, '...')}
                </h3>
            ) : null}
        </header>
    );
};
